import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { source: String };

  click() {
    if (typeof window.userengage !== 'function') return;

    window.userengage('event.kai_upsell_clicked', {
      timestamp: Date.now(),
      device: this._device(),
      data: {
        source: this.sourceValue,
        cta: 'Zleć nam księgowość',
      },
    });
  }

  _device() {
    return /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent) ? 'web_mobile' : 'web_desktop';
  }
}
